<div class="container-fluid">
  <div class="row">
    <div *ngFor="let video of videos" class="col-md-6 mb-3">
        <a [title]="video.name + ' details'" [routerLink]="['/videos', video.id]" class="video">
            <img src="assets/images/{{video.name}}.png" alt="" class="w-100">
          </a>
    </div>
  </div>
</div>